var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9922 0.923828C12.7564 0.923828 13.376 1.54337 13.376 2.30761V6.92023C13.376 7.68447 12.7564 8.30401 11.9922 8.30401C11.2279 8.30401 10.6084 7.68447 10.6084 6.92023V2.30761C10.6084 1.54337 11.2279 0.923828 11.9922 0.923828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2209 5.48151C15.2176 5.70999 15.2727 5.93552 15.3811 6.13669C15.4894 6.33787 15.6474 6.50801 15.84 6.63096C19.3181 8.75606 20.4149 13.2984 18.2898 16.7765C16.1646 20.2546 11.6224 21.3515 8.14424 19.2264C4.6661 17.1013 3.56928 12.5589 5.69442 9.08077C6.30165 8.08695 7.13546 7.25094 8.12767 6.64108C8.32358 6.51812 8.48481 6.34712 8.59606 6.14433C8.70731 5.94154 8.76488 5.71368 8.7633 5.48238C8.76542 4.71814 8.14761 4.09691 7.38337 4.09479C7.12087 4.09405 6.86358 4.16801 6.64153 4.30802C1.88068 7.26517 0.418495 13.5218 3.37559 18.2826C6.33269 23.0434 12.5893 24.5056 17.3501 21.5485C22.1109 18.5914 23.5731 12.3348 20.616 7.57397C19.7929 6.24878 18.6753 5.1312 17.3501 4.30807C16.7016 3.89894 15.8442 4.09302 15.4351 4.74154C15.2953 4.96306 15.2211 5.21959 15.2209 5.48151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3543dfa475128050fbbd1ee890747d47.svg";
export { ForwardRef as ReactComponent };